import { ExchangeError } from '../../../errors.js';
const SERVER = new URL('https://api.aeroswap.io/v2/');
const fetchOrderFromAero = async ({ headers, message, }, fetchival) => {
    const response = await fetchival(SERVER, { headers }).post(message);
    if (!response?.result) {
        throw new ExchangeError({ message: JSON.stringify(response) });
    }
    return response.result[0];
};
const getProviderOrder = async (providerOrder, fetchival) => {
    if (!providerOrder.options?.statusRequestParams) {
        throw new ExchangeError({ message: 'Missing headers for AeroSwap' });
    }
    const aeroOrder = await fetchOrderFromAero(providerOrder.options.statusRequestParams, fetchival);
    return {
        orderId: aeroOrder.id,
        depositAddress: aeroOrder.payinAddress,
        withdrawalAddress: aeroOrder.payoutAddress,
        depositAmount: aeroOrder.amountExpectedFrom,
    };
};
const aeroConfig = {
    aero: getProviderOrder,
    aero2: getProviderOrder,
    aerous: getProviderOrder,
    aero2us: getProviderOrder,
};
export default aeroConfig;
